"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("@doshexchnage/utils");
var react_1 = require("react");
var react_2 = require("@heroui/react");
var useClient_1 = require("../../../../../../../hooks/useClient");
// const ChannelsCellView = ({ cellValue }: IProps) => {
//   if (!cellValue) {
//     return null;
//   }
//   if (!Array.isArray(cellValue)) {
//     return null;
//   }
//   if (Array.from(cellValue)[0] === undefined) {
//     return null;
//   }
//   const shopifyChannel = cellValue?.find((x) => x.channel == "SHOPIFY");
//   const googleChannel = cellValue?.find((x) => x.channel == "GOOGLE");
//   const facebookChannel = cellValue?.find((x) => x.channel == "FACEBOOK");
//   const vodacomChannel = cellValue?.find((x) => x.channel == "VODACOM");
//   return (
//     <div className="flex flex-col sm:flex-row gap-2 items-center">
//       <span className={shopifyChannel ? "text-shopify" : "text-disabled"}>
//         <Icon icon="logos:shopify" />
//       </span>
//       <span className={googleChannel ? "text-google" : "text-disabled"}>
//         <Icon icon="logos:google-icon" />
//       </span>
//       <span className={facebookChannel ? "text-facebook" : "text-disabled"}>
//         <Icon icon="logos:facebook" />
//       </span>
//       <span className="">{vodacomChannel ? <img src={vodacomLogo} className="h-4 w-4" /> : <img src={vodacomLogoDisabled} className="h-4 w-4" />}</span>
//     </div>
//   );
// };
function PriceCellView(_a) {
    var _b;
    var cellValue = _a.cellValue, client = _a.client;
    if (!client) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatMoney)({
            symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
            value: (_b = cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString()) !== null && _b !== void 0 ? _b : "0",
            symbolSeparation: true,
        }) }));
}
function StatusCellView(_a) {
    var cellValue = _a.cellValue;
    var color = (0, react_1.useMemo)(function () {
        if ([
            "ACTIVE",
            "COMPLETED",
            "FUlFILLED",
            "PROCESSED",
            "ORDERED",
            "READY",
            "ARRIVED",
            "DELIVERED",
            "ONLINE",
            "AVAILABLE",
            "COMPLETE",
            "SUCCESS",
            "ACCEPTED",
        ].includes(cellValue)) {
            return "success";
        }
        else if (["INACTIVE", "CANCELLED", "OFFLINE"].includes(cellValue)) {
            return "default";
        }
        else if (["UPDATED", "OPEN", "RETURNED", "PACKED", "VIEWED"].includes(cellValue)) {
            return "default";
        }
        else if (["SUSPENDED", "ABANDONED", "RETURNED-BY-CUSTOMER", "DECLINED", "EXPIRED"].includes(cellValue)) {
            return "danger";
        }
        else if ([
            "AWAITING-SIGNUP",
            "PROCESSING",
            "CHECKED-OUT",
            "POS-ORDERED",
            "COLLECTED",
            "DELIVERY-READY",
            "PARTIALLY-DELIVERED",
            "AWAITING-EMAIL-CONFIRMATION",
            "SENT",
            "PENDING",
        ].includes(cellValue)) {
            return "warning";
        }
        return "default";
    }, [cellValue]);
    return ((0, jsx_runtime_1.jsx)(react_2.Chip, { className: "text-nowrap text-xs capitalize", color: color, size: "sm", variant: "soft", children: cellValue }));
}
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        return [
            { key: "customer", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            { key: "code", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue }) },
            { key: "order_date", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(cellValue)) }) },
            { key: "total", content: (0, jsx_runtime_1.jsx)(PriceCellView, { cellValue: cellValue, client: client }) },
            { key: "branch", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue === null || cellValue === void 0 ? void 0 : cellValue.display_name }) },
            { key: "method", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }) },
            // { key: "channel", content: <ChannelsCellView cellValue={[cellValue]} /> },
            {
                key: "expected_fulfilment_date",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(cellValue)) }),
            },
            // { key: "status", content: TABLE_STATUSES(cellValue ?? "") },
            { key: "status", content: (0, jsx_runtime_1.jsx)(StatusCellView, { cellValue: cellValue }) },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
